import * as React from 'react'
import { Container } from '../styles'
import { Flex } from 'grid-styled'
import Img from 'gatsby-image'
import { Customer, Content, AfterContent } from './styles'

interface IProps {
  image: object
}

export const SEOCases: React.SFC<IProps> = ({ image }) => (
  <Container id="seo">
    <Flex mt={5} justifyContent="center">
      <h1>SEO Success Stories</h1>
    </Flex>
    <Customer>
      <Content color="#bb6103">
        <a href="http://www.justpatios.com.au">
          <img
            src="http://www.justpatios.com.au/assets/logo.png"
            width="144"
            alt="Just Patios logo"
          />
        </a>
        <p>
          Operating in Brisbane and the Sunshine Coast, Just Patios was looking
          to increase sales. We offered them new and innovative growth
          strategies that today make up 100% of their sales and marketing
          system, increasing revenue more than 2x.
        </p>
      </Content>
      <Img fluid={image} />
    </Customer>
    <AfterContent>
      <div>
        <img
          src="https://www.playbook.coach/assets/playbook-icon-c0dae4c3de6bcb1df1482a277e0fe8c72dc80a4830b6332b2229b53e0b201445.png"
          width="64"
          height="46"
          alt="Playbook logo"
        />
        <p>
          PlayBook is an online private coaching startup that was looking to get
          a foothold in Google. Within a few months we helped PlayBook take
          control of important keywords and build a coherent online brand,
          kickstarting their business venture.
        </p>
      </div>
    </AfterContent>
  </Container>
)
